// onboarding — First steps (Onboarding.tsx + OnboardingView.tsx).
// Design: Claude Design session 37, artboards 07a–09d. Keys mirror ../pl/onboarding.ts.
//
// Every step of this wizard performs a REAL backend operation, so the copy may speak in
// the present tense about things that are actually happening. Second rule: no number on
// these screens is a constant — balance, the price of an edit, file limits, word count,
// BPM and render percentage all come from the backend through {placeholders}.
//
// Third rule, new in paczka 37 (rule 8 of the plan): a row of numbers instead of a
// sentence about the balance.
export const onboarding = {
  stepOf: 'Step {n} of 3',
  skip: 'Skip',
  exitFailed: {
    title: 'We did not record the end of your first steps',
    chip: 'Not saved',
    body: 'The account still has the first steps ahead of it. Nothing was lost.',
    retry: 'Try again',
  },
  close: 'Close',

  // Number rows (artboards 07a, 08a, 08c, 08d). Labels, not sentences.
  nums: {
    have: 'You have',
    cost: 'Cost',
    missing: 'Missing',
    edit: 'Edit',
    after: 'Left after',
    before: 'Before',
    now: 'Now',
    none: '-',
  },

  // 09a · The account is being checked — a step INSIDE First steps, not a separate panel.
  pending: {
    title: 'Checking your account',
    step1: 'Upload a track',
    step2: 'Choose clips and a style',
    step3: 'Download the MP4',
    locked: 'Unlocks once the account is approved',
  },

  // 07a · Start.
  welcome: {
    title: 'Let’s start',
    cta: 'Make your first edit',
    loading: 'Checking your balance and prices…',
    error: 'We could not load the price list. Refresh the page - we do not start without prices.',
  },

  // 07b–07g · Step 1: upload, its failures, analysis.
  step1: {
    title: 'Upload a track',
    cta: 'Upload a track',
    drop: 'Drop the file here',
    formats: '{exts} · up to {limit}',
    formatsUnknown: 'mp3, wav, flac, m4a',
    cancel: 'Stop',
    cancelled: 'Upload stopped. Nothing was taken from your account.',
    retry: 'Try again',
    err: {
      chip: 'not uploaded',
      tooLarge: 'This file is {size} and the limit is {limit}. Nothing was taken from your account.',
      type: 'The .{ext} format is not supported. Supported: {allowed}. Nothing was taken from your account.',
      dupChip: 'already in your music',
      dup: 'The same file is already in your Music as “{name}”. Nothing was taken from your account.',
      quota: 'Tracks being analysed: {pending} (limit: {limit}). Nothing was taken from your account.',
      long: 'This track is longer than we accept ({limit}). Nothing was taken from your account.',
      other: 'The file could not be uploaded. Nothing was taken from your account.',
      pick: 'Choose another file',
      useExisting: 'Use the existing track',
    },
    analyzing: {
      words: 'Words',
      wordsDone: '{count} words',
      wordsDone_one: '{count} word',
      wordsDone_few: '{count} words',
      wordsDone_many: '{count} words',
      wordsPending: 'still counting…',
      beats: 'Beat',
      beatsPending: 'still counting…',
      bpm: '{bpm} BPM',
      instrumental: 'no words',
      next: 'Next',
    },
    analysisFailed: {
      title: 'The analysis did not work',
      chip: 'not counted',
      body: 'We could not read the lyrics from this file. Nothing was taken from your account.',
      retry: 'Analyse again',
    },
  },

  // 08a–08c, 08g · Step 2.
  step2: {
    title: 'Choose clips and a style',
    packs: 'Clip pack',
    clips: '{count} clips',
    clips_one: '{count} clip',
    clips_few: '{count} clips',
    clips_many: '{count} clips',
    style: 'Style',
    changeStyle: 'Change style',
    stylePick: 'Choose',
    styleCancel: 'Cancel',
    buy: 'Top up tokens',
    cta: 'Make your first edit',
    // The state word on a disabled tile, the same one as in the generator's step 2.
    noClips: 'no usable clips',
    noPacks: 'We have no ready packs right now. Upload your own footage in the Library, under Clips.',
    noPacksCode: 'packs-0',
    openClips: 'Open Clips',
    retry: 'Try again',
    startFailed: 'The render could not be started. Your tokens stayed on the account.',
    noTokens: 'Not enough tokens for this edit. Buy a bundle in Billing.',
  },

  // 09b · Payments temporarily off (GATE 3).
  gate3: {
    title: 'Payments are temporarily off',
    ok: 'Got it',
    contact: 'Write to us',
  },

  // 08d · Step 3 — the queue and the render share ONE word (rule 30: "rendering"
  // leaves every pill in the product; the tile shows progress, the pill says state).
  step3: {
    chipQueued: 'in queue',
    chipRendering: 'in queue',
  },

  // 08f · Done.
  done: {
    title: 'Your first edit is ready',
    download: 'Download MP4',
  },

  // 08e · The render did not work.
  failed: {
    title: 'The render did not work',
    retry: 'Try again',
    otherPack: 'Choose other clips',
  },
}
